import { Outlet } from 'react-router-dom'
import TopNav from './TopNav/TopNav'
import ModalRoot from '../components/modal/ModalRoot'
import { HelpProvider } from '../help/HelpContext'
import HelpLayer from '../help/HelpLayer'
import './AppLayout.css'

// Shell for authenticated pages: a fixed top nav above a full-height content
// area that each page (Searchrooms, Global Search, ...) fills.
function AppLayout() {
  return (
    <HelpProvider>
      <div className="app-shell">
        <TopNav />
        <main className="app-main">
          <Outlet />
        </main>
        <ModalRoot />
        <HelpLayer />
      </div>
    </HelpProvider>
  )
}

export default AppLayout
